module.exports = __webpack_public_path__ + "img/openListBannerJs.bb708c5.png";